export enum UserActionType {

    ADD_USERS = 'ADD_USERS',
    ADD_USER_INFO = 'ADD_USER_INFO',
    UPDATE_USER_INFO = 'UPDATE_USER_INFO',
    USER_INFO = 'USER_INFO',
    CLEAR_ALL_DATA_USER = 'CLEAR_ALL_DATA_USER',
    OPEN_EDIT_PROFILE = 'OPEN_EDIT_PROFILE',
    CLOSE_EDIT_PROFILE = 'CLOSE_EDIT_PROFILE',
    ADD_PEOPLE_INFO = 'ADD_PEOPLE_INFO',
    HAS_MORE_DATA_PEOPLE = 'HAS_MORE_DATA_PEOPLE',
    NOT_MORE_DATA_PEOPLE = 'NOT_MORE_DATA_PEOPLE',
    REQUEST_PAGE_PEOPLE = 'REQUEST_PAGE_PEOPLE',
    LAST_USER_PEOPLE = 'LAST_POST_PEOPLE',
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    SIGNUP = 'SIGNUP',
    UPDATE_PASSWORD = 'UPDATE_PASSWORD',
    AUTH_ERROR = 'AUTH_ERROR',
    UPDATE = 'UPDATE'
}




// WEBPACK FOOTER //
// ./src/constants/userActionType.ts